let lang = localStorage.getItem('favoriteLanguage') || navigator.language;

if (lang.indexOf('-') !== -1)
	lang = lang.split('-')[0];

if (lang.indexOf('_') !== -1)
	lang = lang.split('_')[0];

const initialState = {
	language: lang,
	isLanguagesListShown: false
};

const languageReducer = ( state = initialState, action ) => {
	switch (action.type) {
		case "SET_LANGUAGE":
			state = {
				...state,
				language: action.payload
			};
			break;
		case "IS_LANGUAGES_LIST_SHOWN":
			state = {
				...state,
				isLanguagesListShown: action.payload
			};
			break;
		default:
			return state;
	}
	return state;
};

export default languageReducer;
